import { useAppSelector } from 'store/useAppSelector';

import {
  selectAuthAddress,
  selectAuthProvider,
  selectAuthToken,
  selectCallback,
  selectIsAPIAuthorizing,
  selectIsAuth0,
  selectIsGithubAuth,
  selectIsGoogleAuth,
  selectIsLoggedIn,
  selectIsMicrosoftAuth,
  selectIsOAuth,
  selectIsSlack,
  selectIsTelegramAuth,
  selectIsWeb3Auth,
  selectIsX,
  selectReferralCode,
  selectWalletIcon,
  selectWalletId,
  selectWalletName,
} from '../store/selectors';

export const useAuth = () => {
  const authAddress = useAppSelector(selectAuthAddress);
  const authProvider = useAppSelector(selectAuthProvider);
  const authToken = useAppSelector(selectAuthToken);
  const callback = useAppSelector(selectCallback);
  const isAPIAuthorizing = useAppSelector(selectIsAPIAuthorizing);
  const isAuth0 = useAppSelector(selectIsAuth0);
  const isGithubAuth = useAppSelector(selectIsGithubAuth);
  const isTelegramAuth = useAppSelector(selectIsTelegramAuth);
  const isMicrosoftAuth = useAppSelector(selectIsMicrosoftAuth);
  const isGoogleAuth = useAppSelector(selectIsGoogleAuth);
  const isSlackAuth = useAppSelector(selectIsSlack);
  const isXAuth = useAppSelector(selectIsX);
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const isOAuth = useAppSelector(selectIsOAuth);
  const isWeb3Auth = useAppSelector(selectIsWeb3Auth);
  const referralCode = useAppSelector(selectReferralCode);
  const walletIcon = useAppSelector(selectWalletIcon);
  const walletId = useAppSelector(selectWalletId);
  const walletName = useAppSelector(selectWalletName);

  const isLoggingIn = isAPIAuthorizing;

  return {
    authAddress,
    authProvider,
    authToken,
    callback,
    hasAuthToken: Boolean(authToken),
    isAuth0,
    isGithubAuth,
    isGoogleAuth,
    isTelegramAuth,
    isMicrosoftAuth,
    isSlackAuth,
    isXAuth,
    isLoggedIn,
    isLoggingIn,
    isOAuth,
    isWeb3Auth,
    referralCode,
    walletIcon,
    walletId,
    walletName,
  };
};
